import React from "react";
import heroImage from "assets/images/performanceRefresh/performance-hero.webp";
import heroImageSm from "assets/images/performanceRefresh/performance-hero-sm.webp";

import loadable from "@loadable/component";

const ImageLoader = loadable(() => import("./../common/ImageLoader"));
/**
 * @returns {JSX.Element}
 * @constructor
 */

const HeroBlock = () => {
  return (
    <section className="p-hero">
      <div className="container">
        <div className="p-hero__content">
          <h1 className="p-hero__title">
            Pound-for-pound, Mila is <br />
            the most powerful air purifier <br />
            on the market.{" "}
          </h1>
          <h4 className="p-hero__subtitle">
            Like if a tiger and a koala had a baby.
          </h4>
          <p className="p-hero__description">
            Mila delivers over 60% more power per pound, at half the size of
            your average air purifier. BOOM.
          </p>
        </div>
      </div>
      <ImageLoader
        className="p-hero__image img-relative"
        placeholderAspectRatio={1444 / 810}
        image={heroImage}
        smallWebp={heroImageSm}
        alt="Performance Hero"
      />
    </section>
  );
};

export default HeroBlock;
